import React, { useState, useEffect, useRef } from "react";
import FluidImage from "/src/utils/FluidImage";

const FiftyFiftyServicesItemImageRight = ( item, index ) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // Disconnect to avoid performance issues
                }
            },
            { threshold: 0.3 }
        );

        if (ref.current) observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            className={`group transition-all duration-1000 ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-1/2 opacity-0"
            }`}
            index={index}
        >
            <div className="lg:hidden relative">
                <img
                            src={item?.title_image.filename}
                            alt={item?.title?.alt}
                            className="opacity-0 w-1/3 h-1/3 right-0 duration-500 transition-all ease-in-out lg:-translate-x-1/4 group-hover:-translate-x-0"
                />
                <img
                            src={item?.title_image.filename}
                            alt={item?.title?.alt}
                            className="absolute w-1/2 md:w-auto z-10 top-0 left-0 duration-500 transition-all ease-in-out lg:-translate-x-1/4 group-hover:-translate-x-0"
                />
            </div>
            <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/2 flex flex-col z-10 order-2 lg:order-1">
                    <div className="my-auto lg:ml-0 lg:mr-24 xl:mx-24 flex flex-col justify-end z-10">
                        <img
                            src={item?.title_image.filename}
                            alt={item?.title?.alt}
                            className="hidden lg:block h2 duration-500 transition-all ease-in-out lg:translate-x-1/4 group-hover:-translate-x-0 mb-9"
                        />
                        <div className="body-text prose">{item?.supporting_text}</div>
                    </div>
                </div>
                <div className="order-1 lg:order-2 w-full lg:w-1/2">
                    <div className="duration-500 transition-all ease-in-out lg:-translate-x-[50px] group-hover:-translate-x-0 mb-8 lg:mb-0">
                        <FluidImage image={item?.image} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FiftyFiftyServicesItemImageRight;
